import React, { Component } from 'react';
import './Page404.scss';
import Img404 from './images/404.jpg';

class Page404 extends Component {
    render() {
        return (
            <div className="page-404">
                <div className="site-main">
                    <img className="tip-img" src={Img404} alt="404" />
                </div>
            </div>
        );
    }
}

export default Page404;
